import { fetchStream } from "@/serve/index";

export default class LLMManager {
  constructor(conversationId = "") {
    this.conversationId = conversationId;
  }

  ask(question, { onMessage, onEnd, onError, onFinished, abortController }) {
    fetchStream({
      conversation_id: this.conversationId,
      msg: question,
      abortController: abortController || new AbortController(),
      onMessage: (data) => {
        if (!this.conversationId && data.conversation_id) {
          this.conversationId = data.conversation_id;
        }

        if (data.event === "message") {
          onMessage && onMessage(data);
        }

        if (data.event === "message_end") {
          onEnd && onEnd();
        }

        if (data.event === "workflow_finished") {
          onFinished && onFinished(data);
        }
        if (data.event === "error") {
          onError && onError(data);
        }
      },
      onError,
    });
  }
}
